import { isNil } from './isNil'

/**
 * Checks if `val` is not `null` or `undefined`.
 *
 * @returns {boolean} `false` if `val` is `undefined` or `null`, otherwise `true`.
 */
export const isNotNil = <T>(val: T | null | undefined): val is T => !isNil(val)
